<template>
<div class="edit-block" style="min-height: 1px">
<div class="post-full-img" :class="{pfileft: block.prefix=='left', pfiright: block.prefix=='right'}" v-if="block.content*1">
  <img :src="photoLink(block.media)" v-if="isPhoto(block.media)" />
  <a class="ext-link" target="_blank" :href="photoLink(block.media)" v-else>Download: {{ fileName(block.media) }}</a>
</div>
<div class="post-full-img add" v-else>
  <div class="video-uploader">
    <label>Drag and drop photo or file here <span></span> or click to select photo</label>
    <input type="file" ref="filechooser" v-on:change="uploadFile" />
  </div>
</div>
<a class="drag"></a>
<a class="remove" v-on:click="$emit('remove')"></a>
<a v-if="isPhoto(block.media)" class="move mleft" v-on:click="block.prefix='left'"></a>
<a v-if="isPhoto(block.media)" class="move mdefault" v-on:click="block.prefix=null"></a>
<a v-if="isPhoto(block.media)" class="move mright" v-on:click="block.prefix='right'"></a>
</div>
</template>

<script>
export default {
  props: ["value", "block"],
  methods: {
    photoLink(media) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return media.store.rootUrl+media.path;
    },
    isPhoto(media) {
      var link=this.photoLink(media);
      if (!link)
        return false;
      var ext=link.split(".").pop().toLowerCase();
      return ["jpg", "jpeg", "jpe", "png", "gif", "webp", "bmp"].indexOf(ext)!=-1;
    },
    fileName(media) {
      var link=this.photoLink(media);
      if (!link)
        return false;
      return link.split("/").pop().replace(/\.[^.]*$/, "");
    },
    uploadFile($event) {
      var file=$event.target.files[0];
      if (!file)
        return;
      this.uploadImage(file);
    },
    async uploadImage(file) {
      var result=await api.create("Media", {store: 1});
      if (result.id) {
        await api.upload("Media", result.id, file);
      }
      var media=(await api.get("Media", result.id)).item;
      this.$set(this.block, "content", media.id);
      this.$set(this.block, "media", media);
    },
  },
}
</script>
